import React from 'react';

export const FlagTRIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 400" // Standard 3:2 ratio
    {...props}
  >
    <rect width="600" height="400" fill="#E30A17" rx="2"/> {/* Red field */}
    {/* Crescent */}
    <circle cx="225" cy="200" r="100" fill="#FFFFFF"/>
    <circle cx="262.5" cy="200" r="80" fill="#E30A17"/>
    {/* Star (5-pointed) */}
    <g transform="translate(362.5 200) rotate(-18)"> {/* Positioned to the right of crescent, slightly rotated */}
      <polygon
        points="0,-40 11.76,-12.36 38.04,-12.36 15.28,6.18 23.51,32.36 0,16 -23.51,32.36 -15.28,6.18 -38.04,-12.36 -11.76,-12.36"
        fill="#FFFFFF"
      />
    </g>
  </svg>
);